import { styled } from '@mui/material';

import { FormProvider, useForm } from 'react-hook-form';

import { useEffect } from 'react';

import { Form, Button } from '@app-velocity/ui';

import { useI18n } from '@app-velocity/i18n';

import { useCurrentUser } from '@app-velocity/libs/auth';

import { UserEmailOptInDto } from '../../../../../../../../dto/UserEmailOptInDto';
import { useUpdateUserDataMutation } from '../../../../../../../../queries/useUpdateUserDataMutation';

import { EmailOptIn } from '../../../../../../../../components/EmailOptIn';

const StyledAction = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
});

const SinglePreference = styled('div')(({ theme }) => ({
  padding: `${theme.spacing(2)} 0`,
  borderBottom: '1px solid #e3e3e3',
}));

export const NotificationsForm = () => {
  const { t } = useI18n();
  const currentUser = useCurrentUser(false);
  const methods = useForm<UserEmailOptInDto>({
    defaultValues: {
      marketingAccepted: true,
    },
  });

  const { handleSubmit, reset } = methods;

  const onSubmit = async (data: UserEmailOptInDto) => {
    updateUser({
      marketingAccepted: data.marketingAccepted,
    });
  };

  useEffect(() => {
    if (!currentUser) return;

    reset({ marketingAccepted: currentUser.marketingAccepted || false });
  }, [currentUser?.marketingAccepted]);

  const { mutate: updateUser, isPending } = useUpdateUserDataMutation();

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <FormProvider {...methods}>
        <SinglePreference>
          <EmailOptIn reversed />
        </SinglePreference>
        <StyledAction>
          <Button
            disabled={isPending}
            variant="contained"
            color="primary"
            type="submit"
          >
            {t('shared:save_preferences')}
          </Button>
        </StyledAction>
      </FormProvider>
    </Form>
  );
};
